import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeaturesVisiblePasswordDirective } from './directives/visible-password.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [FeaturesVisiblePasswordDirective],
  exports: [FeaturesVisiblePasswordDirective],
})
export class CoreFeaturesVisiblePasswordModule {}
